import { FieldDefinition } from "../../../../component/form/field-definition";

export const evaluatorReviewSelectFieldDefinitions: FieldDefinition[] = [
    {
        id: "moduleId",
        name: "Module",
        type: "select",
        required: true,
        disabled: false
    },
    {
        id: "workItemId",
        name: "Badge",
        type: "select",
        required: true,
        disabled: true
    }
];